var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{class:_vm.cssClass,attrs:{"label":_vm.label,"type":_vm.type,"placeholder":_vm.placeholder,"value":_vm.value,"rules":_vm.rules,"required":""},on:{"input":function (e){ return _vm.$emit('input',e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }